import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { useEffect, useState } from "react";
import {
  Checkbox,
  FormControlLabel,
  FormGroup,
  Grid,
  setRef,
} from "@mui/material";
import Typography from "@mui/material/Typography";
import { Aux } from "../../../utils";

export default function Settings(props) {
  const [open, setOpen] = useState(false);
  const [deadband, setDeadband] = useState(0);
  const [setPoint, setSetPoint] = useState(0);
  const [secSetPoint, setSecSetPoint] = useState(0);
  const [speedMeters, setSpeedMeters] = useState([]);
  useEffect(() => {
    setOpen(props.open || false);
    setDeadband(props.deadband || 0);
    setSetPoint(props.setPoint || 0);
    setSecSetPoint(props.secSetPoint || 0);
    if (props.speedMeters)
      setSpeedMeters(JSON.parse(JSON.stringify(props.speedMeters)));
  }, [props.open]);

  const handleClose = (save) => {
    if (save) {
      props.onClose({
        deadband: deadband,
        speedMeters: speedMeters,
        setPoint: setPoint,
        secSetPoint: secSetPoint,
        index: props.index,
        open: false,
      });
    } else {
      props.onClose({ delete: true, index: deadband.index });
    }
  };
  const updateSpeedMeters = (e, key, index) => {
    const newNum = Number(e.target.value);
    if (newNum >= 0) {
      const newSpeedMeters = [...speedMeters];
      newSpeedMeters[index][key] = newNum;
      setSpeedMeters(newSpeedMeters);
    }
  };

  return (
    <div>
      <Dialog fullWidth={true} maxWidth="sm" open={open} onClose={handleClose}>
        <DialogTitle>Settings</DialogTitle>
        <DialogContent>
          <Grid container spacing={1}>
            <Grid item xs={4}>
              <TextField
                autoFocus
                margin="dense"
                id="deadband"
                label="Deadband(%)"
                type="text"
                fullWidth
                variant="standard"
                value={deadband}
                onChange={(e) => {
                  const newNum = Number(e.target.value);
                  if (newNum >= 0 && newNum <= 100) {
                    setDeadband(Number(e.target.value));
                  }
                }}
              />
            </Grid>
            <Grid item xs={4}>
              <TextField
                margin="dense"
                label="PSI Setpoint"
                type="text"
                fullWidth
                variant="standard"
                value={secSetPoint}
                onChange={(e) => {
                  const newNum = Number(e.target.value);
                  if (newNum >= 0) {
                    setSecSetPoint(Number(e.target.value));
                  }
                }}
              />
            </Grid>
            <Grid item xs={4}>
              <TextField
                margin="dense"
                label="Set Point Flow"
                type="text"
                fullWidth
                variant="standard"
                value={setPoint}
                onChange={(e) => {
                  const newNum = Number(e.target.value);
                  if (newNum >= 0) {
                    setSetPoint(Number(e.target.value));
                  }
                }}
              />
            </Grid>
            <Grid item xs={12}>
              <Typography variant="h6" gutterBottom component="div">
                Speed Meters
              </Typography>
            </Grid>
            {speedMeters &&
              speedMeters.map((item, index) => {
                return (
                  <Aux key={`SMCS-${index}`}>
                    <Grid item xs={7}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={item.display}
                            onChange={(e) => {
                              const newSpeedMeters = [...speedMeters];
                              newSpeedMeters[index].display = e.target.checked;
                              setSpeedMeters(newSpeedMeters);
                            }}
                            inputProps={{ "aria-label": "display" }}
                          />
                        }
                        labelPlacement="end"
                        label={item.label?.split('\n')[0]}
                        style={{ paddingTop: "20px" }}
                      />
                    </Grid>
                    <Grid item xs={2}>
                      <TextField
                        margin="dense"
                        label="min"
                        type="text"
                        fullWidth
                        variant="standard"
                        value={item.min}
                        disabled={!item.display}
                        onChange={(e) => updateSpeedMeters(e, "min", index)}
                      />
                    </Grid>
                    <Grid item xs={3}>
                      <TextField
                        margin="dense"
                        label="max"
                        type="text"
                        fullWidth
                        variant="standard"
                        value={item.max}
                        disabled={!item.display}
                        onChange={(e) => updateSpeedMeters(e, "max", index)}
                      />
                    </Grid>
                  </Aux>
                );
              })}
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button color="error" onClick={() => handleClose(false)}>
            Delete Chart
          </Button>
          <Button onClick={() => handleClose(true)}>Save</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
